import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/painel-iptv/revendedores")({
  head: () => ({
    meta: [
      { title: "Painel IPTV para Revendedores - Lucratividade e Estabilidade | P2 PRO" },
      { name: "description", content: "O painel IPTV para revendedores mais completo do Brasil. Gerencie clientes, crie testes e escale seu faturamento com suporte 24h e servidores 4K estáveis." },
      { name: "keywords", content: "painel iptv para revendedores, revenda iptv profissional, sistema de revenda iptv, painel de controle revenda" },
      { property: "og:title", content: "Painel IPTV Profissional para Revendedores | P2 PRO" },
      { property: "og:description", content: "Tenha o controle total da sua revenda com o painel IPTV mais intuitivo e potente do mercado. Ideal para quem busca escala e lucro." },
    ],
  }),
  component: () => (
    <SEOPage
      heroImage="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200"
      variant="split"
      hideBenefits={true}
      hideHowItWorks={true}
      showPriceTable={true}
      category="Revenda Profissional"
      sections={[
        {
          title: "Infraestrutura de Elite para sua Revenda",
          type: "grid",
          content: (
            <>
              {[
                { title: "Servidores Tier 3", desc: "Hospedagem em data centers de nível mundial para latência zero.", icon: "🌐" },
                { title: "Proteção DDoS", desc: "Sua operação protegida contra ataques e instabilidades externas.", icon: "🛡️" },
                { title: "Backup em Tempo Real", desc: "Dados de clientes e créditos seguros com redundância total.", icon: "💾" }
              ].map((item, i) => (
                <div key={i} className="p-8 rounded-3xl bg-white/[0.02] border border-white/5 hover:border-electric/30 transition-all">
                  <div className="text-3xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </>
          )
        },
        {
          title: "Por que escolher a P2 PRO em 2026?",
          type: "featured",
          content: (
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-lg text-white/90 leading-relaxed mb-6">
                  Nossa tecnologia de compressão H.265 garante que seus clientes assistam em 4K Ultra HD consumindo 50% menos internet. Isso reduz drasticamente as reclamações de "travamento" por conta da rede do cliente.
                </p>
                <ul className="space-y-4">
                  {["Canais 24 horas sem delay", "EPG atualizado automaticamente", "Logos de canais em alta definição", "Sinopses completas para VOD"].map((item, i) => (
                    <li key={i} className="flex items-center gap-3 text-white font-bold">
                      <div className="w-2 h-2 bg-white rounded-full" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-black/20 p-8 rounded-[2rem] border border-white/10 backdrop-blur-md">
                <h4 className="text-xl font-black mb-4 italic uppercase">Suporte Dedicado</h4>
                <p className="text-white/70 text-sm leading-relaxed mb-6">
                  Ao se tornar um revendedor parceiro, você ganha acesso a um grupo exclusivo de networking e suporte direto com nossos engenheiros de transmissão.
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-xl">🚀</div>
                  <div>
                    <div className="text-white font-black">Crescimento Acelerado</div>
                    <div className="text-white/50 text-[10px] uppercase tracking-widest">Mentoria Gratuita</div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      ]}
      title="PAINEL IPTV PARA REVENDEDORES: ESCALE SEU LUCRO"
      subtitle="A ferramenta definitiva para gerenciar sua carteira de clientes com eficiência, estabilidade e suporte técnico de elite."
      introParagraphs={[
        "O <a href='/' className='text-electric hover:underline font-bold'>Painel IPTV para Revendedores da P2 PRO</a> foi desenvolvido pensando na agilidade necessária para o dia a dia de quem trabalha no mercado de streaming. Com ele, você tem total autonomia para criar acessos, realizar renovações e oferecer testes gratuitos em poucos segundos.",
        "Nossa plataforma oferece uma visão 360º do seu negócio, permitindo monitorar conexões ativas, gerenciar prazos de validade e configurar pacotes personalizados de acordo com o desejo de cada cliente, garantindo uma taxa de fidelização muito superior à média do mercado.",
        "Seja você um revendedor iniciante ou já consolidado, nossa estrutura pós-pago permite que você cresça de forma sustentável, pagando apenas pelos créditos que utiliza e contando com uma infraestrutura de servidores que suporta grandes eventos e horários de pico sem quedas."
      ]}
      benefits={[
        {
          title: "Gestão Simplificada",
          description: "Interface intuitiva que permite gerenciar centenas de clientes sem complicações técnicas.",
        },
        {
          title: "Testes Ilimitados",
          description: "Gere testes gratuitos para seus potenciais clientes e aumente drasticamente sua taxa de conversão.",
        },
        {
          title: "Suporte Especializado",
          description: "Canal direto com nossa equipe técnica para auxílio em configurações e dúvidas operacionais.",
        }
      ]}
      howItWorks={[
        { title: "Ativação", description: "Seu painel é liberado imediatamente após a adesão ao nosso sistema de revenda." },
        { title: "Configuração", description: "Personalize seus planos e defina as regras de acesso para seus clientes." },
        { title: "Vendas", description: "Utilize nossos materiais de marketing e testes para atrair e fechar novos usuários." },
        { title: "Escala", description: "Reinvista seus lucros e expanda sua rede de clientes com total segurança técnica." }
      ]}
      diferenciais={[
        { title: "Servidores 4K/8K", description: "Qualidade de imagem premium para satisfazer os clientes mais exigentes." },
        { title: "Painel Responsivo", description: "Gerencie sua revenda de qualquer lugar através do seu smartphone ou tablet." },
        { title: "Relatórios de Consumo", description: "Acompanhe detalhadamente o uso de cada crédito e a saúde do seu negócio." }
      ]}
      faq={[
        {
          question: "Como recebo meus acessos ao painel?",
          answer: "Após a confirmação, você recebe seus dados de acesso por e-mail e WhatsApp em poucos minutos."
        },
        {
          question: "Posso criar sub-revendedores?",
          answer: "Sim, nosso painel permite que você crie sua própria rede e gerencie outros revendedores abaixo de você."
        },
        {
          question: "O painel é seguro contra ataques?",
          answer: "Sim, utilizamos criptografia de ponta e proteção DDoS para garantir que sua operação nunca pare."
        }
      ]}
      breadcrumbs={[
        { label: "Painel IPTV", href: "/painel-iptv" },
        { label: "Revendedores", href: "/painel-iptv/revendedores" }
      ]}
      relatedArticles={[
        { title: "Painel IPTV Pós Pago", href: "/painel-iptv/pos-pago" },
        { title: "Melhor Painel IPTV", href: "/painel-iptv/melhor" },
        { title: "Franquia IPTV", href: "/painel-iptv/franquia" }
      ]}
    />
  ),
});
